module.exports = __webpack_public_path__ + "img/fail.2f255eb4.png";